import { useState } from "react";

import { AllowedProductProfileEditForm } from "src/app/features/AllowedProductProfile/components/forms/AllowedProductProfileEditForm";
import { ActionBar } from "../../../../components/ActionBar/ActionBar";
import { PageTitle } from "../../../../components/AppLayout/components/Content/components";
import { FPage, FPageContent, FPageHeader } from "../../../../components/AppLayout/components/FPageLayout";
import { BackButton } from "../../../../components/FeatureButtons/BackButton";
import { SubmitButton } from "../../../../components/FeatureButtons/SubmitButton";
import { canAccess } from "../../../../core/router/auth/permissions";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { BASE_PATH } from "../../../../core/router/types/routerTypes";

export const AllowedProductProfileEditFormPage = () => {
    const [runSubmit, setRunSubmit] = useState(0);
    const triggerFormSubmit = () => setRunSubmit(runSubmit + 1);
    const hasWriteAccess = canAccess(ResourceName.ALLOWED_PRODUCT_PROFILES, "basicTabsWrite");

    return (
        <FPage>
            <FPageHeader>
                <PageTitle translationKey="page.title.allowedProductProfilesEditFormPage" />
                <ActionBar>
                    <SubmitButton isDisabled={!hasWriteAccess} onClick={triggerFormSubmit} />
                    <BackButton isDisabled={false} url={`${BASE_PATH}/${ResourceName.ALLOWED_PRODUCT_PROFILES}`} />
                </ActionBar>
            </FPageHeader>
            <FPageContent>
                <AllowedProductProfileEditForm runSubmit={runSubmit} />
            </FPageContent>
        </FPage>
    );
};
